// Under Natasha's Google Account
export const recaptchSiteKey = "6Lc7LoIjAAAAABJjLG7K8_KzIteBaZY78udwG01k";

// export const apiBaseURL = "http://ketos:8045"; //USE FOR STAGING. Endpoint fix
export const apiBaseURL = "https://atlasboard.wsu-idp.org/backend"; //USE FOR PRODUCTION. Endpoint fix
// export const apiBaseURL = "https://atlasweb-dev.hq.wsuniar.org:8080"; //USE FOR STAGING PRODUCTION. Endpoint fix
